import { render, staticRenderFns } from "./CrewAssignmentList.vue?vue&type=template&id=a260b9f6&scoped=true"
import script from "./CrewAssignmentList.vue?vue&type=script&lang=js"
export * from "./CrewAssignmentList.vue?vue&type=script&lang=js"
import style0 from "./CrewAssignmentList.vue?vue&type=style&index=0&id=a260b9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a260b9f6",
  null
  
)

export default component.exports